export type SystemParameters = {
  LastMonthlyReportProcessingDate: Date,
  LastWeeklyReportProcessingDate: Date,
  emailLastAt: Date,
  privacyPolicyUrl: Date
};

export type CreateState = {
  id: string;
  tenantId?: string;
  deleteFlg?: boolean;
  userCount: number;
  createCount: number;
  status: "inOparation" | "standBy" | "completion" | "error";
  missingNumber?: number[];
};

export type SystemParameter00000001 = {
  optionContract: optionConfig[];
  machitappuUrl: string;
};

export type optionConfig = {
  optionName: string;
  sort: number;
  status: boolean;
  optionId: string;
};

export type UserCardCreateState = {
  id: string;
  tenantId: string;
  createNo?: number;
  status: "waitRequest" | "standBy" |  "inOperation" | "completion" | "impossible" | "error";
  createCount: number;
  excelFileName: string;
  excelFilePath: string;
  dispExcelFileName: string;
  pdfFileName?: string;
  pdfFilePath?: string;
  requestAt: Date | null;
  createAt: Date | null;
  createUserUid?: string;
  errorUserMaps?: ErrorUserMap[];
  requestUserUid: string;
};

export type ErrorUserMap = {
  userId: string;
  userName: string;
  message: string[];
};

export const userCardTimestampToDate = (data: any | undefined): UserCardCreateState => {
  if(data.createAt && data.createAt !== null){
    data.createAt = new Date(data.createAt.seconds * 1000);
  }
  if(data.requestAt && data.requestAt !== null){
    data.requestAt = new Date(data.requestAt.seconds * 1000);
  }
  return data;
};
